export { DMS_MODULE } from '../../constants';
export const AKCNI_PRODEJ_ND_POLOZKY = 'AkcniProdejNdPolozky';
export const CRUMB_LABEL_KEY = 'edtAkcniProdej';
export const NAME = 'AkcniProdejNd';

export const depTableNames = <const>[AKCNI_PRODEJ_ND_POLOZKY];

export type DepTableNames = typeof depTableNames[number];
